import React from "react";
import { Divider, Typography, makeStyles } from "@material-ui/core";
import { FileUpload } from "mdi-material-ui";
import { ThemeType } from "@theme";
import { FormSection } from "@components/forms/common";
import { PrimaryButton, RegularButton } from "@components";
import { DnDLocalContainer } from "@containers/DnDContainer/DnDLocalContainer";
import { useUploadRequest } from "@hooks";

type Props = {
  className?: string;
  children: React.ReactNode;
  title: string;
  primaryButtonText: string;
  isOk: boolean;
  requestSent: boolean;
  dropToUploadText: string;
  switchText: string;
  requestSentContent?: React.ReactNode;
  onUpload: (files: File[]) => void;
  onMakeRequest: () => void;
};

export function BookingHospitalityDocumentSection(props: Props) {
  const classes = useStyles({});
  const { requestUpload } = useUploadRequest(true);

  const sendRequestButton = !props.requestSent ? (
    <PrimaryButton
      variant="outlined"
      style={{ marginBottom: 8, whiteSpace: "nowrap" }}
      onClick={props.onMakeRequest}
    >
      {props.primaryButtonText}
    </PrimaryButton>
  ) : (
    <RegularButton
      variant="outlined"
      style={{ marginBottom: 8, whiteSpace: "nowrap" }}
      onClick={props.onMakeRequest}
    >
      {props.primaryButtonText}
    </RegularButton>
  );

  return (
    <FormSection
      flat
      fullWidth
      withBorder
      PaperProps={{ className: props.className, style: { padding: 0 } }}
    >
      <DnDLocalContainer
        className={classes.withFileUpload}
        overlayProps={{ className: classes.dndOverlay }}
        onDrop={props.onUpload}
        noClick
      >
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            padding: 8
          }}
        >
          <Typography variant="h6">{props.title}</Typography>
        </div>

        <Divider style={{ opacity: 0.5, marginBottom: 0 }} />

        <div
          style={{
            padding: 8,
            paddingTop: 16,
            flex: 1,
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap"
          }}
        >
          {sendRequestButton}

          {props.requestSentContent && (
            <div style={{ flex: "1 0 100%" }}>{props.requestSentContent}</div>
          )}
        </div>

        <Divider style={{ opacity: 0.5, marginBottom: 0 }} />

        <RegularButton
          variant="text"
          leftIcon={<FileUpload />}
          onClick={() => requestUpload().then((files) => props.onUpload(files))}
          style={{ margin: "8px auto" }}
        >
          {props.dropToUploadText}
        </RegularButton>

        <div style={{ flex: "1 1 100%" }}>{props.children}</div>
      </DnDLocalContainer>
    </FormSection>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  dndOverlay: { borderRadius: 4 },

  withFileUpload: {
    // borderStyle: "dashed",
    display: "flex",
    flex: 1,
    flexWrap: "wrap",
    justifyContent: "space-between",
    // padding: 16,
    paddingTop: 0,
    paddingBottom: 0,

    "& hr": {
      flex: "1 0 100%",
      margin: "0 0 16px 0"
    }
  }
}));
